<div class="modal-container" *ngIf="visible">

  <div class="modal-overlay clickable" (click)="closeAction()"></div>
  <div class="modal" role="dialog" [class.modal-single]="size == 'single'">
      <ng-content select="modal-error"></ng-content>
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <i (click)="closeAction()" class="icon-close-thin"></i>
                  <ng-content select="header"></ng-content>
              </div>
              <div class="modal-body">
                  <ng-content select="content"></ng-content>
              </div>
              <div *ngIf="showFooter" class="modal-footer">
                  <ng-content select="footer"></ng-content>
              </div>
          </div>
      </div>
  </div>
</div>
